import { useEffect, useSyncExternalStore } from 'react';

import Cookies from 'js-cookie';

import { isAuthenticated, onUserStateChange } from '../features/authentication/authentication';

export function isSuspendedAndAuthenticated(): boolean {
  return isAuthenticated() && Boolean(Cookies.get('account_suspended'));
}

export function useIsSuspended(): boolean {
  return useSyncExternalStore(onUserStateChange, isSuspendedAndAuthenticated);
}

export function useSuspendedCookie() {
  const isUserSuspended = useIsSuspended();

  useEffect(() => {
    if (isUserSuspended) {
      window.location.reload();
    }
  }, [isUserSuspended]);
}
